import React, { useRef, useState } from "react";
import { Editor } from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import "./style.css";
import { tw } from "@careinfo/tailwind";
import { classNames } from "../../../utils/classNames";
import NavBar from "./NavBar";
import HeaderEditor from "./HeaderEditor";
import FooterEditor from "./FooterEditor";
import BodyEditor from "./BodyEditor";

const GrapesJSEditor: React.FC = () => {
  const [activeEditor, setActiveEditor] = useState("body");
  const editorList = ["body", "header", "footer"];
  const editorRef = useRef<Editor | null>(null);
  const editorHeaderRef = useRef<Editor | null>(null);
  const editorFooterRef = useRef<Editor | null>(null);

  const handleDisable = (editor: string) => {
    setActiveEditor(editor);
    if (editorRef.current) {
      const body = editorRef.current.Canvas.getBody();
      if (body) body.style.pointerEvents = "none";
      // editorRef.current.select(null);
    }
    if (editorHeaderRef.current) {
      const body = editorHeaderRef.current.Canvas.getBody();
      if (body) body.style.pointerEvents = "none";
      // editorHeaderRef.current.select(null);
    }
    if (editorFooterRef.current) {
      const body = editorFooterRef.current.Canvas.getBody();
      if (body) body.style.pointerEvents = "none";
      // editorFooterRef.current.select(null);
    }
    if (editor === "body") {
      const body = editorRef.current.Canvas.getBody();
      if (body) body.style.pointerEvents = "auto";
    } else if (editor === "header") {
      const body = editorHeaderRef.current.Canvas.getBody();
      if (body) body.style.pointerEvents = "auto";
    } else if (editor === "footer") {
      const body = editorFooterRef.current.Canvas.getBody();
      if (body) body.style.pointerEvents = "auto";
    }
  };

  return (
    <>
      <NavBar />
      <div className={tw`page flex relative h-[calc(100vh-50px)]`}>
        <div className={tw`w-[200px] sticky top-50 bg-gray-600 overflow-auto`}>
          <div className={tw`flex w-full justify-between`}>
            {editorList.map((editor) => (
              <button
                key={editor}
                onClick={() => handleDisable(editor)}
                className={tw`py-2 w-full text-capitalize focus:outline-none ${
                  activeEditor === editor ? "bg-gray-300" : "bg-gray-200"
                }`}
              >
                {editor}
              </button>
            ))}
          </div>
          <div
            id="body-blocks"
            className={classNames(
              activeEditor === "body" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="header-blocks"
            className={classNames(
              activeEditor === "header" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="footer-blocks"
            className={classNames(
              activeEditor === "footer" ? tw`block` : tw`hidden`
            )}
          />
        </div>
        <div className={tw`flex-1 overflow-auto sticky top-50 p-4`}>
          <HeaderEditor
            handleDisable={handleDisable}
            editorHeaderRef={editorHeaderRef}
          />
          <BodyEditor handleDisable={handleDisable} editorRef={editorRef} />
          <FooterEditor
            handleDisable={handleDisable}
            editorFooterRef={editorFooterRef}
          />
        </div>
        <div className={tw`w-[200px] bg-gray-600 sticky top-50 overflow-auto`}>
          <div
            id="body-selector"
            className={classNames(
              activeEditor === "body" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="header-selector"
            className={classNames(
              activeEditor === "header" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="footer-selector"
            className={classNames(
              activeEditor === "footer" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="body-trait"
            className={classNames(
              activeEditor === "body" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="header-trait"
            className={classNames(
              activeEditor === "header" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="footer-trait"
            className={classNames(
              activeEditor === "footer" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="body-style"
            className={classNames(
              activeEditor === "body" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="header-style"
            className={classNames(
              activeEditor === "header" ? tw`block` : tw`hidden`
            )}
          />
          <div
            id="footer-style"
            className={classNames(
              activeEditor === "footer" ? tw`block` : tw`hidden`
            )}
          />
        </div>
      </div>
    </>
  );
};

export default GrapesJSEditor;
